// src/pages/homePage/HomePage.jsx (or .js)
import { useEffect } from 'react';

export default function HomePage() {
  useEffect(() => {
    // Use replace so the back button doesn't immediately bounce back here
    window.location.replace('https://cloudinary.com/demos?filter=videos');
  }, []);

  return;
}
